import React from 'react';
import { MarkDown } from "./index";
function TypeScriptTab(props) {
    return (
        <MarkDown src={props.src} />
    )
}

export default TypeScriptTab